<template>
	<div class="baseTag" :class="computedClass">
		<div v-if="slots.leadingIcon" class="inline-flex">
			<slot name="leadingIcon"></slot>
		</div>
		<span v-if="slots.default" data-btn-text>
			<slot></slot>
		</span>
		<span v-if="slots.trailingIcon" class="inline-flex">
			<slot name="trailingIcon"></slot>
		</span>
	</div>
</template>

<script setup lang="ts">
import { computed, type PropType, useSlots } from 'vue'

const slots = useSlots()

enum TagVariant {
	Success = 'success',
	Highlight = 'highlight',
	Error = 'error',
	NoAction = 'no-action',
	Info = 'info',
	Dark = 'dark',
	Black = 'black',
}

enum TagSize {
	Small = 'small',
	Medium = 'medium',
}

const tagVariants = {
	[TagVariant.Success]: 'bg-g-50 text-g-600',
	[TagVariant.Highlight]: 'bg-o-50 text-o-500',
	[TagVariant.Error]: 'bg-r-100 text-r-700',
	[TagVariant.NoAction]: 'bg-n-50 text-n-950',
	[TagVariant.Info]: 'bg-t-50 text-t-600',
	[TagVariant.Dark]: 'bg-n-950 text-white',
	[TagVariant.Black]: 'bg-b-25% text-n-950',
}

const tagSizes = {
	[TagSize.Small]: 'typography-c2-reg h-[20px] gap-4px px-[6px] py-0',
	[TagSize.Medium]: 'typography-c1-reg h-[24px] gap-4px px-[8px] py-0',
}

type VariantType = `${TagVariant}`
type SizeType = `${TagSize}`

const props = defineProps({
	variant: {
		type: String as PropType<VariantType>,
		default: TagVariant.Success,
	},
	size: {
		type: String as PropType<SizeType>,
		default: TagSize.Small,
	},
})

const computedClass = computed(() => {
	const classes = `
		inline-flex items-center rounded-full
		${tagVariants[props.variant]}
		${tagSizes[props.size]}
	`
	return classes
})
</script>
